import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import useDarkMode from '../../hooks/useDarkMode';

import UserContext from '../../contexts/UserContext';

import {
  AvatarIcon,
  HouseIcon,
  LogOutIcon,
  MoonIcon,
  SunIcon,
} from '../../images/shapes';

export const useUserMenuItems = () => {
  const { t } = useTranslation();
  const { isAdmin } = useContext(UserContext);
  const [darkMode, setDarkMode] = useDarkMode();

  const userMenuItems = useMemo(() => {
    const currentMenuUserItems = [
      {
        id: 'dark-mode-change',
        onClick: () => setDarkMode(!darkMode),
        text: darkMode
          ? t('Global.ChooseLightTheme')
          : t('Global.ChooseDarkTheme'),
        icon: darkMode ? (
          <SunIcon className="w-4 text-white" />
        ) : (
          <MoonIcon className="w-4 text-indigo-950" />
        ),
      },
      {
        id: 'profile-page',
        link: '/profile',
        text: t('Global.ProfileSettings'),
        icon: (
          <AvatarIcon className="text-indigo-950 dark:text-white w-4 h-4 " />
        ),
      },
      {
        id: 'logout',
        link: '/logout',
        text: t('Global.LogOut'),
        icon: (
          <LogOutIcon className="text-indigo-950 dark:text-white w-4 h-4 " />
        ),
      },
    ];

    if (isAdmin) {
      currentMenuUserItems.splice(1, 0, {
        id: 'organization-page',
        link: '/organization',
        text: t('Global.OrganizationSettings'),
        icon: <HouseIcon className="w-4 h-4 text-indigo-950 dark:text-white" />,
      });
    }

    return currentMenuUserItems;
  }, [t, isAdmin, setDarkMode, darkMode]);

  return { userMenuItems };
};
